<script setup>
import {onMounted, ref} from "vue";
import Grid from "../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import {ucFirst} from "../../../../frontend/src/helpers/string";

const {items, gridParams, gridMethods} = useGrid(getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
    },
    {
        label: 'Name',
        name: 'name',
    },
    {
        label: 'Description',
        name: 'description',
    },
    {
        label: 'Enterprise',
        name: 'enterprise_name',
    },
    {
        label: 'Created by',
        name: 'user_email',
    },
    {
        label: 'Created At',
        name: 'created_at',
    },
    {
        label: 'Share Type',
        name: 'ecosystems_share_type',
    },
    {
        label: 'Public Status',
        name: 'public_status',
    },
    {
        label: 'Status',
        name: 'status',
    },
    {
        label: 'Added by AI',
        name: 'ai_count',
    },
    {
        label: 'Matched Startups',
        name: 'matched_count',
    },
    {
        label: 'Submitted Startups',
        name: 'submitted_count',
    },
    {
        label: 'Liked',
        name: 'liked_count',
    },
    {
        label: 'Disliked',
        name: 'disliked_count',
    },
];

const id = ref(null);
const listType = ref(null);
const showModal = ref(false);

onMounted(() => {
    gridMethods.setColumns(columns);
});

function getList(params) {
    return needsService.getEcosystemNeeds(id.value, listType.value, params);
}

function open(ecosystemId, type) {
    id.value = ecosystemId;
    listType.value = type;

    gridMethods.resetList();
    showModal.value = true;
}

defineExpose({
    open
});

</script>

<template>
    <b-modal v-model="showModal" :title="`${ucFirst(listType)} needs`" hide-footer modal-class="modal-w-xxxl">
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :currentPage="gridParams.currentPage"
                    class="mb-3"
                    @changePage="gridMethods.changePage"
                />
            </div>
        </div>
    </b-modal>
</template>

<style scoped>

</style>
